import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class CartService extends BaseService {

    static url = "cart";
    static apis = {
        addKitToCart: { path: this.url, method: "POST" },
        removeKitFromCart: { path: this.url + 's', method: "DELETE" },
        addKitToCartAuthenticated: { path: this.url + 's', method: "POST"},
        UpdateCart: { path: this.url + 's/update-cart', method: "POST"},
        confirmAvailability: { path: this.url + 's/confirm-availability', method: "GET"},
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("customers");
    }

    addKitToCart(id, cart, { message = undefined }) {
        var that = this;
        var data = { id: id, cart: cart }
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CartService.apis.addKitToCart.path,
                    method: CartService.apis.addKitToCart.method,
                    data: data,
                    authorization: false,
                    showLoader: true,
                    message: message
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
    removeKitFromCart(id, { message = undefined }) {
        var that = this;
        var data = {kit_id: id};
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CartService.apis.removeKitFromCart.path,
                    method: CartService.apis.removeKitFromCart.method,
                    data: data,
                    authorization: true,
                    showLoader: true,
                    message: message
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    addKitToCartAuthenticated(data, cart, { message = undefined }) {
        var that = this;
        var data = { kit_id: data.kit, cart: cart, quantity:data.quantity}
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CartService.apis.addKitToCartAuthenticated.path,
                    method: CartService.apis.addKitToCartAuthenticated.method,
                    data: data,
                    authorization: true,
                    showLoader: true,
                    message: message
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    confirmAvailability(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CartService.apis.confirmAvailability.path+'/'+id,
                    method: CartService.apis.confirmAvailability.method,
                    authorization: false,
                    showLoader: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    UpdateCart(cart) {
        var that = this;
        var data = {cart: cart}

        return new Promise((resolve, reject) => {
            that.axios({
                    url: CartService.apis.UpdateCart.path,
                    method: CartService.apis.UpdateCart.method,
                    data: data,
                    authorization: true,
                    showLoader: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}

export default CartService;